export const MIN_ELAPSED_MINUTES_TO_RE_TRIGGER_JOB = 5;
